<script setup lang="ts">
import DollarBadgeOutline from "@/Components/Icons/DollarBadgeOutline.vue";
import DollarBadgeSolid from "@/Components/Icons/DollarBadgeSolid.vue";
import GearOutline from "@/Components/Icons/GearOutline.vue";
import GearSolid from "@/Components/Icons/GearSolid.vue";
import IdCardOutline from "@/Components/Icons/IdCardOutline.vue";
import IdCardSolid from "@/Components/Icons/IdCardSolid.vue";
import ScrewdriverWrenchOutline from "@/Components/Icons/ScrewdriverWrenchOutline.vue";
import ScrewdriverWrenchSolid from "@/Components/Icons/ScrewdriverWrenchSolid.vue";
import UsersGearSolid from "@/Components/Icons/UsersGearSolid.vue";
import UserSolid from "@/Components/Icons/UserSolid.vue";
import NavFlyoutButton from "@/Components/Nav/NavFlyoutButton.vue";
import NavLink from "@/Components/Nav/NavLink.vue";
import useGuard from "@/Composables/useGuard";
import type NavLinkType from "@/Types/NavLink";
import { computed } from "vue";

const props = defineProps({
    expanded: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["click-link"]);

const guard = useGuard();

const navLinks = computed((): NavLinkType[] => [
    {
        label: "Clients",
        icon: IdCardOutline,
        iconActive: IdCardSolid,
        visible: true,
        active: route().current("clients.*"),
        href: route("clients.index"),
    },
    {
        label: "Bids",
        icon: DollarBadgeOutline,
        iconActive: DollarBadgeSolid,
        visible: true,
        active: route().current("bids.*"),
        href: route("bids.index"),
    },
    {
        label: "Vendors",
        icon: ScrewdriverWrenchOutline,
        iconActive: ScrewdriverWrenchSolid,
        visible: true,
        active: route().current("vendors.*"),
        href: route("vendors.index"),
    },
    // {
    //     label: "Contacts",
    //     icon: ContactIcon,
    //     visible: true,
    //     active: route().current("contacts.*"),
    //     href: route("contacts.index"),
    // },
    {
        label: "Settings",
        icon: GearOutline,
        iconActive: GearSolid,
        visible: guard.can("access admin"),
        active: route().current("settings.*"),
        children: [
            {
                label: "Users",
                icon: UserSolid,
                visible: true,
                href: route("settings.users.index"),
            },
            {
                label: "Roles",
                icon: UsersGearSolid,
                visible: true,
                href: route("settings.roles.index"),
            },
        ],
    },
]);
</script>

<template>
    <div class="flex flex-col gap-y-2">
        <template
            v-for="link in navLinks"
            :key="link.label"
        >
            <NavLink
                v-if="'href' in link && link.visible"
                :href="link.href"
                :active="link.active ?? false"
                :label="link.label"
                :expanded="expanded"
                :icon="link.icon"
                :icon-active="link.iconActive"
                @click="emit('click-link')"
            />

            <NavFlyoutButton
                v-if="'children' in link && link.visible"
                :label="link.label"
                :expanded="expanded"
                :icon="link.icon"
                :icon-active="link.iconActive"
                :active="link.active"
                :children="link.children"
                @click-link="emit('click-link')"
            />
        </template>
    </div>
</template>
